/* Dark PDP: the GoKwik side cart renders inside a shadow root (<shadow-dom-container>), so
   pdp-dark-theme.css cannot reach it and the page-wide inversion would turn the cart dark.
   Add the same counter-inversion inside the shadow root so the cart and its dim overlay keep
   their normal look. Images need no rule: they sit under both inversions and net out. */
(function () {
  var HOST = 'shadow-dom-container';
  var RULE = '.overlay, .sidecart { filter: invert(1) hue-rotate(180deg); }';

  function patch() {
    var host = document.querySelector(HOST);
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.querySelector('style[data-pdp-dark]')) {
      var style = document.createElement('style');
      style.setAttribute('data-pdp-dark', '');
      style.textContent = RULE;
      host.shadowRoot.appendChild(style);
    }
    return true;
  }

  if (patch()) return;

  var observer = new MutationObserver(function () {
    if (patch()) observer.disconnect();
  });
  observer.observe(document.body || document.documentElement, { childList: true });
})();
